export const normalizePhoneNumber = (phone: string): string =>
  phone.replace(/[^\d]/g, '');
